<owl-carousel-o [options]="carouselOptions" class="no-arrow">
  <ng-container *ngFor="let blog of blogs">
    <ng-template carouselSlide>
      <div class="col-md-12">
        <a [routerLink]="'/pages/blog'">
          <div class="classic-effect">
            <img [src]="blog.imageUrl" class="blogimg" alt="blog" />
            <span></span>
          </div>
        </a>
        <div class="blog-details">
          <h4 style="text-transform: capitalize">
            {{ blog.createdAt | date : "dd,MMMM,YYYY" }}
          </h4>
          <a [routerLink]="'/pages/blog'">
            <p>{{ blog.title }}</p>
          </a>
          <hr class="style1" />
          <!-- <h6>{{ "by:" + blog.by }} , {{ "2 Comment" }}</h6> -->
        </div>
      </div>
    </ng-template>
  </ng-container>
</owl-carousel-o>
